export default "__VITE_ASSET__Dcuy7EA3__"